module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_signalnco_m.b42f5e7852a9914c43f2a8fc2445cde6.png";